import { Component, inject } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AiHubLoaderService } from "@aihub/ui/loader";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
  standalone: true,
  selector: "postgenie-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.scss"],
  imports: [CommonModule, ReactiveFormsModule, RouterModule, MatTooltipModule],
})
export class PostgenieSideMenu {
  router = inject(Router);
  loaderService = inject(AiHubLoaderService);

  isLoading$ = toSignal(this.loaderService.loader$);

  navigateTo(route: string): void {
    this.router.navigate([route], {
      queryParamsHandling: "merge",
    });
  }
}
